import React from "react";
const CalendarFooter: React.FC<{ onSelect: (date: Date | undefined) => void }> = (props) => {
	const todayButton = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		// send today value back to parent component
		props.onSelect(new Date());
	}

	return (
		<button
			type="button"
			onClick={(e) => todayButton(e)}
			className="w-full py-2 px-4 bg-newTheme-lime text-black rounded-lg transition-colors font-karla"
		>
			Select Today
		</button>
	)
}
export default CalendarFooter;